import React, { FC, useState } from "react";
import { Button, IconButton } from "@mui/material";
import FeatherIcon from "feather-icons-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";

import FormBasics from "./components/FormBasics";
import FormBasicsCsob from "./components/FormBasics/FormBasicsCsob";
import SortSections from "./components/SortSections";

import { AssetQuestionnaireModal } from "@components/main/csob/hub";
import FormBasicsDialog from "@components/main/co2/hub/CollectData/components/FormBasicsDialog";
import { useMultistepFormStore } from "@components/common/MultistepForm";
import { Box, Stack, Typography } from "@components/base";
import { CreateUpdateFormDialog } from "@components/main/forms";

interface HeaderProps {}

const Header: FC<HeaderProps> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formEditorOpen, setFormEditorOpen] = useState(false);
  const [formBasicsOpen, setFormBasicsOpen] = useState(false);
  const [sortSectionsOpen, setSortSectionsOpen] = useState(false);
  const {
    formSettings: { returnUrl, isCsobForm, editMode, formBasics },
    filteredSections,
  } = useMultistepFormStore();

  return (
    <Box>
      <Stack direction="row" alignItems="center" padding={3} gap={2}>
        {returnUrl && (
          <IconButton
            onClick={() => navigate(returnUrl)}
            size="small"
            color="inherit"
          >
            <FeatherIcon icon="arrow-left" size={20} />
          </IconButton>
        )}
        <Typography variant="subtitle2">
          {formBasics.name || t("common.newForm")}
        </Typography>
      </Stack>

      {!editMode && formBasics.name && (
        <Box flexGrow={1} ml={2} mr={2}>
          {isCsobForm ? (
            <FormBasicsCsob onEdit={() => setFormBasicsOpen(true)} />
          ) : (
            <FormBasics onEdit={() => setFormBasicsOpen(true)} />
          )}
        </Box>
      )}

      {editMode && (
        <Box flexGrow={1} ml={2} mr={2}>
          <Button
            variant="text"
            size="extraSmall"
            onClick={() => setFormEditorOpen(true)}
            startIcon={<FeatherIcon icon="edit" size={16} />}
          >
            {t("multistepForm.editFormBasics")}
          </Button>
          {!isEmpty(filteredSections) && (
            <Button
              variant="text"
              size="extraSmall"
              onClick={() => setSortSectionsOpen(true)}
              startIcon={<FeatherIcon icon="list" size={16} />}
              color="warning"
            >
              {t("multistepForm.sortSections")}
            </Button>
          )}
        </Box>
      )}

      {isCsobForm ? (
        <AssetQuestionnaireModal
          isOpen={formBasicsOpen}
          onClose={() => setFormBasicsOpen(false)}
          isEdit={true}
          formId={formBasics.id}
        />
      ) : (
        <FormBasicsDialog
          open={formBasicsOpen}
          onClose={() => setFormBasicsOpen(false)}
        />
      )}

      <CreateUpdateFormDialog
        open={formEditorOpen}
        formBasics={formBasics}
        onClose={() => setFormEditorOpen(false)}
      />

      <SortSections
        open={sortSectionsOpen}
        onClose={() => setSortSectionsOpen(false)}
        formId={formBasics.id}
        formSections={filteredSections}
      />
    </Box>
  );
};

export default Header;
